import { Link } from "@inertiajs/react"
import type { ComponentProps } from "react"

import { cn } from "@/lib/utils"

type LinkProps = ComponentProps<typeof Link>

export default function TextLink({
  className = "",
  children,
  ...props
}: LinkProps) {
  return (
    <Link
      className={cn(
        "text-krown-100 hover:text-krown-50 underline-offset-4 transition-colors duration-300 ease-out hover:underline",
        className,
      )}
      {...props}
    >
      {children}
    </Link>
  )
}
